/* eslint-disable @typescript-eslint/no-explicit-any */
import { MultiSelectWithSearch } from "@/components/form-input";
import { Checkbox } from "@/components/ui/checkbox";
import { TableCell, TableRow } from "@/components/ui/table";
import React from "react";

export const CustomerSelectionRow = ({
  item,
  data,
  index,
  checked,
  onToggleForDeletion,
  onBranchChange,
}: {
  item: any;
  data: any;
  onChange: any;
  index: number;
  checked: boolean;
  onToggleForDeletion: () => void;
  onBranchChange: (branchId: (string | number)[]) => void;
}) => {
  return (
    <TableRow data-state={checked ? "selected" : undefined}>
      <TableCell>
        <Checkbox checked={checked} onCheckedChange={onToggleForDeletion} />
      </TableCell>
      <TableCell>{index + 1}</TableCell>
      <TableCell>{data?.display_name}</TableCell>
      <TableCell isLineClampDisable>
        <MultiSelectWithSearch
          options={data?.branch_list || []}
          value={
            Array.isArray(item?.branches)
              ? item.branches.map((branch: any) => branch?.id)
              : []
          }
          onChange={onBranchChange}
          bindValue={"branch_id"}
          bindLabel={"branch_name"}
          placeholder="Select Branch"
          noLimit
        />
      </TableCell>
    </TableRow>
  );
};
